<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <gj-country-server-select
            v-model="filter.countryMarketValue"
        >
        </gj-country-server-select>
        <gj-select
            v-model="filter.orderStatusList"
            :options="option.saleOrderStatus"
            placeholder="全部状态"
            multiple
            collapseTags
            width="160px"
        >
        </gj-select>
        <gj-select-input
            v-model="filter.keyword"
            :options="option.saleOrderDynKey"
        >
        </gj-select-input>
        <gj-select-date-picker
            v-model="filter.date"
            type="daterange"
            :options="[
                {id: 'purchaseDate', text: '订购时间'},
                {id: 'recordDate', text: '记录时间'}
            ]"
        >
        </gj-select-date-picker>

        <template  #right>
          <view-setting
                  :ref="REF_VIEW_SETTING"
                  save-mode="remote"
                  :use-default="true"
                  :module-name="moduleName"
                  :config="model"
                  :fn-generate-params="generateViewParams"
                  @view-change="handleChangeView"
                  @view-complete="handCompleteView"

          >
          </view-setting>
        </template>

        <template #advancedFilter>
          <gj-select
              v-model="filter.promoteFee"
              :options="option.stateOption"
              width="120px"
              placeholder="是否录入费用"
          >
          </gj-select>
          <gj-select
              v-model="filter.refunded"
              :options="option.stateOption"
              placeholder="是否退款"
          >
          </gj-select>
          <gj-category-select
              v-model="filter.categoryIds"
              multiple
              width="150px"
              placeholder="全部品类"
          >
          </gj-category-select>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button v-if="$permission('testOrder:import')" type="primary" @click="importPromoteOrder">导入推广订单</gj-button>
      <gj-button v-if="$permission('testOrder:unmarkTest')" @click="batchCancelPromote"
                 :disabled="selectedRows.length === 0">取消标记推广
      </gj-button>
    </template>
    <template #tool-group>
      <gj-tool-group
          setting help
          :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :download="$permission('testOrder:export')" download-url="/operation/testOrder/export" :download-params="globalParams">
      </gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :data="data"
          :columns="columns"
          :name="tableName"
          :pagination="pagination"
          :loading="loading"
          :show-overflow="false"
          selection
          :size="'has-picture'"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
      >
        <template v-slot:orderId="{row}">
          <div>
            {{row.orderId}}
            <span v-copy="row.orderId"
                  class="copy-icon gj-cell-display-switch">
              <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
          </div>
          <div style="display: block; padding-top: 4px">
            <template v-if="row.fulfillmentChannel === 'AFN'">
              <gj-tag type="dark" :color="tagColors.blue">
                FBA
              </gj-tag>
            </template>

            <template v-if="row.fulfillmentChannel === 'AFM'">
              <gj-tag type="dark" :color="tagColors.green">
                FBM
              </gj-tag>
            </template>

            <template v-if="row.returned">
              <gj-tag type="dark" :color="tagColors.red">
                退货
              </gj-tag>
            </template>

            <template v-if="row.refunded">
              <gj-tag type="dark" :color="tagColors.red">
                退款
              </gj-tag>
            </template>
          </div>
        </template>
        <template v-slot:picture="{row}">
          <template v-for="item in row.items">
            <div :key="item.id">
              <gj-image :src="item.imageUrl"></gj-image>
            </div>
          </template>
        </template>
        <template v-slot:msku="{row, index}">
          <template v-for="item in row.items">
            <div :key="item.id" :class="[(index + 1) !== row.items.lenght ? 'order-item-mg8' : '']">
              <gj-tooltip :text-line="1" :content="item.title">
                {{item.title}}
              </gj-tooltip>
              <el-row>
                <el-col :span="10">
                  <el-row>
                    <el-col :span="20">
                      <gj-tooltip :text-line="1" :content="item.asin">
                        <a :href="item.asinUrl" target="_blank">
                          {{item.asin}}
                        </a>
                      </gj-tooltip>
                    </el-col>
                    <el-col :span="4" v-if="item.asin">
                      <span v-copy="item.asin"
                            class="copy-icon gj-cell-display-switch">
                        <gj-icon class="el-icon-copy-document"></gj-icon>
                      </span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="14">
                  <el-row>
                    <el-col :span="20">
                      <gj-tooltip :text-line="1" :content="item.msku">
                        {{item.msku || '-'}}
                      </gj-tooltip>
                    </el-col>
                    <el-col :span="4" v-if="item.msku">
                      <span v-copy="item.msku"
                            class="copy-icon gj-cell-display-switch">
                        <gj-icon class="el-icon-copy-document"></gj-icon>
                      </span>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </template>
        </template>
        <template v-slot:sku="{row, index}">
          <template v-for="item in row.items">
            <div :key="item.id" :class="[(index + 1) !== row.items.lenght ? 'order-item-mg8' : '']">
              <gj-tooltip :text-line="1" :content="item.productName" v-if="item.sku">
                {{item.productName | defaultShow}}
              </gj-tooltip>
              <el-row type="flex">
                <RelateProductComponent :data="generatorRelateItem(row, item)"/>
              </el-row>
            </div>
          </template>
        </template>
        <template v-slot:category="{row, index}">
          <template v-for="item in row.items">
            <div :key="item.id" :class="[(index + 1) !== row.items.lenght ? 'order-item-mg20' : '']">
              {{item.categoryName | defaultShow}}
            </div>
          </template>
        </template>
        <template v-slot:promotePrincipal="{row, index}">
          <template v-for="item in row.items">
            <div :key="item.id" :class="[(index + 1) !== row.items.lenght ? 'order-item-mg20' : '']">
              <div>{{item.principalCurrencySymbol}}{{item.principal | defaultShow}}</div>
            </div>
          </template>
        </template>
        <template v-slot:promoteCommission="{row, index}">
          <template v-for="item in row.items">
            <div :key="item.id" :class="[(index + 1) !== row.items.lenght ? 'order-item-mg20' : '']">
              <div>{{item.commissionCurrencySymbol}}{{item.commission | defaultShow}}</div>
            </div>
          </template>
        </template>
        <template v-slot:quantity="{row, index}">
          <template v-for="item in row.items">
            <div :key="item.id" :class="[(index + 1) !== row.items.lenght ? 'order-item-promotion-mg20' : '']">
              <div>{{item.quantityOrdered}}</div>
            </div>
          </template>
        </template>
        <template v-slot:buyerInfo="{row}">
          <gj-tooltip :text-line="1" :content="row.buyerName">{{row.buyerName | defaultShow}}</gj-tooltip>
          <gj-tooltip :text-line="1" :content="row.buyerEmail">{{row.buyerEmail | defaultShow}}</gj-tooltip>
        </template>
        <template v-slot:memo="{row}">
          <template v-for="(item, index) in row.items">
            <div :key="item.id" :class="[(index + 1) !== row.items.length ? 'order-item-promotion-mg20' : '']">
              <template v-if="$permission('testOrder:editMemo')">
                <gj-edit-input
                    :value="item.memo"
                    :item="item"
                    table-cell-edit
                    :on-confirm="onMemoConfirm"
                    :pop-title="'编辑备注'"
                ></gj-edit-input>
              </template>
              <template v-else>
                {{item.memo}}
              </template>
            </div>
          </template>
        </template>
        <template v-slot:orderStatus="{row}">
          <gj-tag type="text" style="margin-right: 10px" shape="rectangle"
                  :color="row.orderStatus | optionColor(saleOrderStatus)">
            {{ row.orderStatus | optionText(saleOrderStatus) }}
          </gj-tag>
          <!-- {{statusMap[row.orderStatus].text}} -->
        </template>
        <template v-slot:op="{row}">
          <gj-button v-if="$permission('order:view')" type="text" @click="opDetailModal(row)">详情</gj-button>
          <gj-button v-if="$permission('testOrder:unmarkTest')" type="text" @click="cancelPromote(row.id)">取消标记
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {saleOrderDynKey1, saleOrderDynKey2, saleOrderStatus, stateOptionBoolean} from "../../../../utils/options";
  import SaleOrderDetail from "../saleOrder/modal/sale-order-detail";
  import {queryMixin, selectionMixin, isMeaningfulMixin} from "../../../../minxins";
  import {
    batchRemovePromoteOrder,
    exportPromoteOrder,
    getPromoteOrder,
    removePromoteOrder, updatePromoteOrderMemo
  } from "@/api/sale";
  import {convertToDate, generateViewParams} from "@/utils/date.util";
  import {isMeaningful} from "@/utils/common";
  import promoteOrderImport from './promote-order-import';
  import {mapGetters} from "vuex";
  import model from './viewConfig'

  import { RelateProductComponent }from '@/views/components/relate-product/index'
  import { tagColors } from "@/components/tag/tag-colors";

  export default {
    name: "promote-order",
    mixins: [selectionMixin, queryMixin, isMeaningfulMixin],
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    components: {
      RelateProductComponent
    },
    data() {
      return {
        tagColors,
        tableName: 'promote-order',
        data: [],
        columns: [
          {
            id: 'marketId',
            header: '店铺/国家',
            field: 'option:marketId',
            minWidth: '140px',
            fixed: 'left',
            default: true,
            disabled: true,
            options: () => this.marketOption
          },
          {
            id: 'orderId',
            header: '订单编号',
            field: 'slot:orderId',
            minWidth: '190px',
            fixed: 'left',
            default: true,
            disabled: true,
          },
          {
            id: 'picture',
            header: '图片',
            field: 'slot:picture',
            minWidth: '60px',
            fixed: 'left',
            default: true,
            disabled: true,
          },
          {
            id: 'msku',
            header: '商品标题/ASIN/MSKU',
            field: 'slot:msku',
            minWidth: '280px',
            fixed: 'left',
            default: true,
            disabled: true,
          },
          {id: 'product', header: '产品名称/SKU', field: 'slot:sku', minWidth: '180px', default: true},
          {id: 'category', header: '品类', field: 'slot:category', minWidth: '120px', default: false},
          {
            id: 'promotePrincipal',
            header: '推广本金',
            field: 'slot:promotePrincipal',
            minWidth: '120px',
            align: 'right',
            default: true
          },
          {
            id: 'promoteCommission',
            header: '推广佣金',
            field: 'slot:promoteCommission',
            minWidth: '120px',
            align: 'right',
            default: true
          },
          {id: 'quantity', header: '数量', field: 'slot:quantity', minWidth: '50px', align: 'right', default: true},
          {
            id: 'totalAmount',
            header: '订单总金额',
            field: 'orderTotal',
            minWidth: '150px',
            align: 'right',
            default: true,
            prefix: 'currencySymbol'
          },
          {id: 'buyerInfo', header: '买家姓名/邮箱', field: 'slot:buyerInfo', minWidth: '150px', default: true},
          {id: 'purchaseDate', header: '订购时间', field: 'purchaseDate', minWidth: '155px', default: true},
          {
            id: 'status',
            header: '状态',
            field: 'slot:orderStatus',
            minWidth: '120px',
            default: true,
            // options: saleOrderStatus
          },
          {id: 'recordUser', header: '记录用户', field: 'userName', minWidth: '155px', default: true},
          {id: 'recordDate', header: '记录时间', field: 'creatTime', minWidth: '155px', default: true},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '120px', default: true},
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '140px', fixed: 'right', default: true, notCustomColumn: true},
        ],
        filter: {
          countryMarketValue: null,
          orderStatusList: null,
          keyword: {
            key: 'orderId',
            value: null,
          },
          date: {
            key: 'recordDate',
            value: null,
          },
          refunded: null,
          promoteFee: null,
          categoryIds: []
        },
        saleOrderStatus,
        option: {
          saleOrderStatus: saleOrderStatus,
          saleOrderDynKey: [
            {id: 'orderId', text: '订单编号'},
            {id: 'asin', text: 'ASIN'},
            saleOrderDynKey2[1],
            saleOrderDynKey2[2],
            saleOrderDynKey1[1],
            saleOrderDynKey1[3]
          ],
          stateOption: stateOptionBoolean,
        },
        model,
        moduleName: 'PROMOTE_ORDER',
        cacheOptions: {
          useCache: true,
        }
      }
    },
    methods: {
      generateViewParams,
      loadViewComplete () {
        this.$emit('query')
      },
      generatorRelateItem ({ marketId }, { msku, sku }) {
        return {
          marketId,
          msku,
          sku
        }
      },
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{countryMarketValue: *}}
       */
      $gjCacheCallback(params) {
        return {
          countryMarketValue: params.countryMarketValue
        };
      },
      $gjQuery() {
        this.loading = true;
        const params = {
          model: {
            orderStatusList: this.filter.orderStatusList,
            refunded: this.filter.refunded,
            updatedFee: this.filter.promoteFee,
            categoryIds: this.filter.categoryIds,
          },
          ...this.queryPagination,
          ...this.querySort,
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        if (this.filter.countryMarketValue) {
          params.model.marketIds = this.filter.countryMarketValue.marketIds;
          params.model.countryCodes = this.filter.countryMarketValue.countryIds;
        }
        if (isMeaningful(this.filter.date.value)) {
          if (this.filter.date.key === 'recordDate') {
            params.model.createStartDate = convertToDate(this.filter.date.value[0]);
            params.model.createEndDate = convertToDate(this.filter.date.value[1]);
          } else {
            params.model.purchaseStartDate = convertToDate(this.filter.date.value[0]);
            params.model.purchaseEndDate = convertToDate(this.filter.date.value[1]);
          }
        }
        this.globalParams = params;
        getPromoteOrder(params)
          .then((data) => {
            this.data = data.records;
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            countryMarketValue: null,
            orderStatusList: null,
            keyword: {
              key: 'orderId',
              value: null,
            },
            date: {
              key: 'recordDate',
              value: null,
            },
            refunded: null,
            promoteFee: null,
            categoryIds: []
          }
        }
      },
      batchCancelPromote() {
        const vm = this;
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '取消标记推广',
            content: `确定要移除推广订单的标记？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm() {
              modal.confirmLoading = true;
              batchRemovePromoteOrder({ids: vm.selectedRows.map(v => v.id)})
                .then(() => {
                  vm.$gjMessage.success('操作成功');
                  vm.$gjResetPage();
                  modal.$gjDestroy();
                }).complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      download() {
        exportPromoteOrder(this.globalParams)
      },
      opDetailModal(row) {
        this.$gjCreate(SaleOrderDetail, {
          props: {
            marketId: row.marketId,
            orderId: row.orderId,
          }
        })
      },
      cancelPromote(id) {
        const vm = this;
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '取消标记确认',
            content: `确定要移除推广订单的标记？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm() {
              modal.confirmLoading = true;
              removePromoteOrder(id)
                .then(() => {
                  vm.$gjMessage.success('操作成功');
                  vm.$gjResetPage();
                  modal.$gjDestroy();
                }).complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      onMemoConfirm(memo, data, closeEditor) {
        updatePromoteOrderMemo({id: data.id, memo: memo}).then(() => {
          data.memo = memo;
          this.$gjMessage.success('操作成功');
          this.$gjResetPage();
          closeEditor();
        }).complete(() => closeEditor());
      },
      importPromoteOrder() {
        const modal = this.$gjCreate(promoteOrderImport, {
          on: {
            importFileSuccess: () => {
              this.$gjResetPage();
            },
            importSuccess: () => {
              modal.$gjDestroy();
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .order-item-mg8 {
    margin-bottom: 8px;
  }

  .order-item-mg20 {
    margin-bottom: 20px;
  }

  .order-item-promotion-mg20 {
    margin-bottom: 20px;
  }

  .order-tag-mb4 {
    margin-bottom: 4px;
  }

  /deep/ .el-col-20 a {
    color: #1F6EEF;
    text-decoration-line: none;
  }
  .copy-icon{
    margin-left: 0;
  }
</style>
